import React, { Component } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';

const meta = {
	description: 'You may have heard about the recent surge in Bitcoin prices over the past few months.',
	image: '/images/blog-cryptocurrency/cryptocurrency.png',
	title: 'Cryptocurrency: a new type of digital dominance | blueshyft',
	url: 'https://blueshyft.com.au/blogs/cryptocurrency',
};

import '../../css/about.css';

export default class About extends Component {
	render () {

		return (
			<React.Fragment>
				<Helmet
					title={meta.title}
					meta={[
						{ name: 'description', content: meta.description },
						{ property: 'og:title', content: meta.title },
						{ property: 'og:url', content: meta.url },
						{ property: 'og:site_name', content: 'Blueshyft' },
						{ property: 'og:type', content: 'website' },
						{ property: 'og:image', content: meta.image },
						{ property: 'og:description', content: meta.description },
						{ property: 'twitter:card', content: 'summary_large_image' },
						{ property: 'twitter:site', content: '@Blueshyft' },
						{ property: 'twitter:title', content: meta.title },
						{ property: 'twitter:description', content: meta.description },
						{ property: 'twitter:image', content: meta.image },
					]}
				/>

				<section className="about-cryptocurrency">
					<div className="about-cryptocurrency-sub">
						<div className="about-cryptocurrency-image-container">
							<img src="/images/blog-cryptocurrency/cryptocurrency.png" alt="crpyotcurrency" className="about-cryptocurrency-image" />
						</div>
					</div>
				</section>


				<section className="wrapup">
					<div className="block block-crypto">
						<p>You may have heard about the recent surge in Bitcoin prices over the past few months. This sharp rise in cryptocurrency prices is becoming increasingly frequented across media outlets as the general public, coupled with major institutions, are beginning to pay a lot more attention to the digital currency.</p>
					</div>

					<div className="block block-crypto">
						<h4>Institutional influence</h4>
						<p>The primary reason behind Bitcoin’s growth revolves around institutional interest and investment. Recently, owner of Tesla and billionaire, Elon Musk, invested US$1.5 billion into Bitcoin. In turn, many investors saw this bold move as an important milestone in Bitcoin’s journey, and thus, invested heavily themselves. Additionally, Mastercard announced that they will allow merchants to receive payments in cryptocurrency towards the end of the year. Other major institutions that are planning a cryptocurrency integration include PayPal subsidiary, Venmo, and investment bank, BNY Mellon. This interest from major corporations will likely result in further interest from other large companies around the world.</p>
					</div>

					<div className="block block-crypto">
						<h4>blueshfyt's role</h4>
						<p>In regards to blueshyft, we are the first payment gateway in Australia that allows customers to purchase cryptocurrency over the counter. This has revolutionised the transactional process for consumers, enabling efficiency and convenience in a cryptocurrency ecosystem that many see as complex and inaccessible. Purchasing cryptocurrency can be a daunting task for first-time investors, with many considering physical deposit points safer than conducting their transactions online. With more and more people utilising exchanges to purchase digital currencies, blueshyft has become a key player/facilitator in providing investors with an alternative way of purchasing cryptocurrencies.</p>
					</div>

					<div className="block block-crypto">
						<p>In the coming months, there are likely to be many more developments in the cryptocurrency space. More to come. </p>
					</div>
				</section>

			</React.Fragment>
		);
	}
};



// WEBPACK FOOTER //
// ./client/scenes/blog-20210302/index.js